import AxiosMockAdapter from 'axios-mock-adapter';
import axios from './axios';
import {RestAcessoPost, RestAcessoGet} from './acesso/index-f';
import {RestEmpresasGet, RestEmpresasPost} from './empresas/index-f';
import {RestUsersGet, RestUsersPost} from './usuarios/index-f';
import {RestConsultaPost} from './consultas/index-f';
import {RestHistoryNfePost, RestHistoryNfeGet} from './historyNfe/index-f';
import {RestHistoryCtePost, RestHistoryCteGet} from './historyCte/index-f';
import {RestHistoryMdfePost, RestHistoryMdfeGet} from './historyMdfe/index-f';
import {RestHistoricoGtvePost, RestHistoricoGtveGet} from './historicoGtve/index-f';
import {RestHistoryNfsePost, RestHistoryNfseGet} from './historyNfse';
import {RestHistoryNfcePost, RestHistoryNfceGet} from './historyNfce/index-f';
import {RestHistorySatPost, RestHistorySatGet} from './historySat';
import {RestHistoryNf3ePost, RestHistoryNf3eGet} from './historyNf3e/index-f';
import {RestPermGet} from './permissoes/index-f';
import {RestDashGet, RestDashPost} from './dashboard/';
import {RestDashV2Post, RestDashV2Get} from './dashboardv2';
import {RestDashNfePost} from './dashboardNfe';
import {RestDashNfsePost} from './dashboardNfse';
import {RestAplicativosGet, RestAplicativosPost} from './aplicativos';
import RestChangelogPost from './changelog';
import {RestVisitantePost, RestVisitanteGet} from './visitante';
import {RestDataInitPost, RestDataInitGet} from './initDados/index-f';
import {RestRelatoriosGet, RestRelatoriosPost} from './relatorios/index-f';
import {RestRelatoriosExpressNfePost} from './relatorios/relatorios-express-nfe-f';
import {RestRelatorioAvancadoPost} from './relatorios/relatorio-avancado-f';
import {RestRastroNfeGet, RestRastroNfePost} from './rastroNfe/index-f';
import {RestComentariosDocGet, RestComentariosDocPost} from './comentariosDoc/index-f';
import { RestTenantNotificationsGet, RestTenantNotificationsPost } from './tenantNotifications/index-f';
import { RestTicketsGet, RestTicketsPost } from './tickets/index-f';
import { RestIntegracoesGet, RestIntegracoesPost } from './integracoes/index-f';

import { RestTwoFactorGet, RestTwoFactorPost } from './twofactor/';
// import {RestRelatoriosGet, RestRelatoriosPost} from './relatorios/';
import RestFaturasGet from './faturas';
import { RestPlanosGet, RestPlanosPost } from './meuPlano';
import { RestResgateXmlGet, RestResgateXmlPost } from './resgateXML';
import { RestDashResgatePost } from './resgateXML/dashboard';
import { RestRelatoriosResgateXmlPost } from './resgateXML/relatorios-f';
import { RestDossieAutomaticoPost, RestDossieAutomaticoGet } from './dossieAutomatico';
import { RestIaUsageGet } from './iaUsage/index-f';
import { RestConsultasAutomaticasGet } from './consultasAutomaticas/index-f';


// Pertinente a APIV2 E Webhooks
import { RestWebhooksGet, RestWebhooksPost } from './webhooks/index-f';
import { RestApiV2Get, RestApiV2Post } from './apiv2/index-f';





const services = new AxiosMockAdapter(axios, {delayResponse: 0});
/*
services.onGet('/api/empresas/trocaPrimeiraEmpA1').reply(async (config) => {
    return new Promise(function (resolve, reject) {
        try {
            const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
            const storage = JSON.parse(usersRt);
            const emp = storage[0];

            $.ajax({
                url: 'http://192.168.0.33/src/api/controller/empresas_controller.class.php',
                type: 'GET',
                dataType: 'json',
                data: {
                    act: 'trocaPrimeiraEmpresa',
                    key: emp
                },
                success: async function (data, status, xhr) {

                    storage[11][0] = { 'primeiroAcesso': false, 'possuiEmpresas': false };
                    const cript = base64_encode(JSON.stringify(storage));
                    localStorage.setItem("ddesp", cript);
                    
                    window.location.href = '/dashboard/tipoTeste';
                    //reject ([400, { message: 'Dados não localizados' }]);
                    resolve([200]);

                },
                error: function (xhr, status, error) {
                    
                }

            });

        } catch (err) {
            reject([500, { message: 'Server Error' }]);
        }
    });
});*/

// ============================================================= //DataInicial
// Usa regex para casar URL absoluta/relativa e com/sem barra final.
services.onPost(/\/api\/initData\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestDataInitPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

services.onGet(/\/api\/initData\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestDataInitGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// =========================================================== //account
services.onPost(/\/api\/account\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestAcessoPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

services.onGet(/\/api\/account\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestAcessoGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //dashboard
services.onGet(/\/api\/dashboard\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestDashGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

services.onPost(/\/api\/dashboard\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestDashPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //dashboardv2 (gestão)
services.onPost(/\/api\/dashboardv2\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestDashV2Post(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

services.onGet(/\/api\/dashboardv2\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestDashV2Get(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //dashboardNfe
services.onPost(/\/api\/dashboardNfe\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestDashNfePost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //dashboardNfse
services.onPost(/\/api\/dashboardNfse\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestDashNfsePost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //users
services.onPost(/\/api\/users\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestUsersPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

services.onGet(/\/api\/users\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestUsersGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //tenantNotifications (novo fluxo - nao mexe no /api/users notificacoes)
// Usa regex para casar URL absoluta/relativa e com/sem barra final.
services.onPost(/\/api\/tenantNotifications\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestTenantNotificationsPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, { message: err }]);
    }
  });
});

// ============================================================= //integracoes (webhooks)
services.onGet(/\/api\/integracoes\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestIntegracoesGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, { message: err }]);
    }
  });
});

services.onPost(/\/api\/integracoes\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestIntegracoesPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, { message: err }]);
    }
  });
});

services.onGet(/\/api\/tenantNotifications\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestTenantNotificationsGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, { message: err }]);
    }
  });
});

// ============================================================= //tickets (visão do usuário)
services.onGet(/\/api\/tickets\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestTicketsGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, { message: err }]);
    }
  });
});

services.onPost(/\/api\/tickets\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestTicketsPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, { message: err }]);
    }
  });
});

// ============================================================= //consultas
services.onPost(/\/api\/consultas\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestConsultaPost(config);
      resolve(ret);
    } catch {
      reject([500, {message: 'Server Error'}]);
    }
  });
});

// ============================================================= //rastro NF-e (rastreabilidade por lote)
services.onPost(/\/api\/rastroNfe\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestRastroNfePost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

services.onGet(/\/api\/rastroNfe\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestRastroNfeGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //comentarios documentos
services.onPost(/\/api\/comentariosDoc\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestComentariosDocPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

services.onGet(/\/api\/comentariosDoc\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestComentariosDocGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //empresas
services.onGet(/\/api\/empresas\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestEmpresasGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

services.onPost(/\/api\/empresas\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestEmpresasPost(config);
      resolve(ret);
    } catch {
      reject([500, {message: 'Server Error'}]);
    }
  });
});

// ============================================================= //history NF-e
services.onPost(/\/api\/historyNfe\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestHistoryNfePost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});
services.onGet(/\/api\/historyNfe\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestHistoryNfeGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //history NF-e
services.onPost(/\/api\/historyNfce\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestHistoryNfcePost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});
services.onGet(/\/api\/historyNfce\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestHistoryNfceGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});
// ============================================================= //history NF-e
services.onPost(/\/api\/historyNfse\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestHistoryNfsePost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});
services.onGet(/\/api\/historyNfse\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestHistoryNfseGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //history CT-e
services.onPost(/\/api\/historyCte\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestHistoryCtePost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});
services.onGet(/\/api\/historyCte\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestHistoryCteGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //history MDF-e
services.onPost(/\/api\/historyMdfe\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestHistoryMdfePost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});
services.onGet(/\/api\/historyMdfe\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestHistoryMdfeGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});















// ============================================================= //autenticação 2 fatores
services.onPost('/api/twofactor/').reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestTwoFactorPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

services.onGet('/api/twofactor/').reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestTwoFactorGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});
// ============================================================= //history GT-Ve
services.onPost(/\/api\/historicoGtve\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestHistoricoGtvePost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});
services.onGet(/\/api\/historicoGtve\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestHistoricoGtveGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});
// ============================================================= //history SAT-e
services.onPost(/\/api\/historySat\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestHistorySatPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});
services.onGet(/\/api\/historySat\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestHistorySatGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //history CT-e
services.onPost(/\/api\/relatorio\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const parsed = JSON.parse(config.data);
      const dest = (parsed?.dest ?? '').toString().trim();

      // Express NF-e segue fluxo dedicado
      // (todos os relatórios/ações de NF-e express)
      const isExpressNfe =
        dest === 'expressGetColunas' ||
        dest === 'expressGetModelos' ||
        dest === 'expressSaveModelo' ||
        dest === 'expressListagemNfeCompleta' ||
        dest === 'expressListagemProdutosPeriodo' ||
        dest === 'expressListagemParticipantes' ||
        dest === 'expressTotaisPorFornecedor' ||
        dest === 'expressTotaisPorNCM' ||
        dest === 'expressTotaisImpostos' ||
        dest === 'expressTotaisNovosImpostos' ||
        dest === 'expressNovosImpostosDetalhado' ||
        dest === 'expressNfeCanceladas' ||
        dest === 'expressNfeDenegadas' ||
        dest === 'expressNfeFinalidades' ||
        dest === 'expressNfeComDifal' ||
        dest === 'expressNfeComFcp' ||
        dest === 'expressNfeMedicamentos' ||
        dest === 'expressNfeCombustiveis' ||
        dest === 'expressNfeVeiculos' ||
        dest === 'expressNfeExportacao' ||
        dest === 'expressNfeImportacao' ||
        dest === 'expressAnaliseCfop' ||
        dest === 'expressAnaliseCstIcms' ||
        dest === 'expressAnaliseCstPisCofins' ||
        dest === 'expressNcmCfopCruzado' ||
        dest === 'expressNfePorUfOrigem' ||
        dest === 'expressNfePorUfDestino' ||
        dest === 'expressFluxoInterestadual' ||
        dest === 'expressCceListagem' ||
        dest === 'expressMatrizComplexidadeFiscalNfeRecebidas' ||
        dest === 'expressRankingPrazosFornecedor' ||
        dest === 'expressListagemPagamentos' ||
        dest === 'expressDuplicatasVencer' ||
        dest === 'expressDuplicatasProximos30Dias' ||
        dest === 'expressFaturasAnalise';   

      const ret = RestRelatoriosPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});
services.onGet(/\/api\/relatorio\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestRelatoriosGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});
//========================================================================
// ============================================================= 
services.onPost(/\/api\/expressNfe\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestRelatoriosExpressNfePost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});



// ============================================================= //history NF3-e
services.onPost(/\/api\/historyNf3e\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestHistoryNf3ePost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});
services.onGet(/\/api\/historyNf3e\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestHistoryNf3eGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //permissoes
services.onGet(/\/api\/perm\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestPermGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //loja aplicativos
services.onPost(/\/api\/aplicativos\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestAplicativosPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

services.onGet(/\/api\/aplicativos\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestAplicativosGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //faturas
services.onGet(/\/api\/faturas\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestFaturasGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //planos
services.onPost(/\/api\/meuPlano\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestPlanosPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

services.onGet(/\/api\/meuPlano\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestPlanosGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //resgateXML
services.onPost(/\/api\/resgateXML\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestResgateXmlPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

services.onGet(/\/api\/resgateXML\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestResgateXmlGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //relatoriosResgateXml
services.onPost(/\/api\/relatoriosResgateXml\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestRelatoriosResgateXmlPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //dashboardResgate
services.onPost(/\/api\/dashboardResgate\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestDashResgatePost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// =========================================================== //changelog
services.onPost(/\/api\/changelog\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestChangelogPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// =========================================================== //visitante (questionario do cadastro, publico)
services.onPost(/\/api\/visitante\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestVisitantePost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

services.onGet(/\/api\/visitante\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestVisitanteGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= \/\/dossieAutomatico
services.onPost(/\/api\/dossieAutomatico\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestDossieAutomaticoPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

services.onGet(/\/api\/dossieAutomatico\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestDossieAutomaticoGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //relatorioAvancado
services.onPost(/\/api\/relatorioAvancado\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestRelatorioAvancadoPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //iaUsage
services.onGet(/\/api\/iaUsage\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestIaUsageGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});

// ============================================================= //consultasAutomaticas
services.onGet(/\/api\/consultasAutomaticas\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestConsultasAutomaticasGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, {message: err}]);
    }
  });
});


// ============================================================= (webhooks)
services.onGet(/\/api\/webhooks\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestWebhooksGet(config);
      resolve(ret);
    } catch (err) {
      reject([500, { message: err }]);
    }
  });
});

// ============================================================= (webhooks)
services.onGet(/\/api\/apiV2\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestApiV2Get(config);
      resolve(ret);
    } catch (err) {
      reject([500, { message: err }]);
    }
  });
});




services.onPost(/\/api\/webhooks\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestWebhooksPost(config);
      resolve(ret);
    } catch (err) {
      reject([500, { message: err }]);
    }
  });
});

services.onPost(/\/api\/apiV2\/?$/).reply(async (config) => {
  return new Promise(function (resolve, reject) {
    try {
      const ret = RestApiV2Post(config);
      resolve(ret);
    } catch (err) {
      reject([500, { message: err }]);
    }
  });
});





